import { render, staticRenderFns } from "./CarInfo.vue?vue&type=template&id=4ebdb8aa&scoped=true"
import script from "./CarInfo.vue?vue&type=script&lang=ts"
export * from "./CarInfo.vue?vue&type=script&lang=ts"
import style0 from "./CarInfo.vue?vue&type=style&index=0&id=4ebdb8aa&prod&lang=scss&scoped=true"
import style1 from "./CarInfo.vue?vue&type=style&index=1&id=4ebdb8aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebdb8aa",
  null
  
)

export default component.exports